module.exports = __webpack_public_path__ + "static/img/18.d7185be6.png";